(function () {
  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function destroyGallery(el) {
    if (!el || !el._cardMobileGallery) return;
    try {
      el._cardMobileGallery.destroy(true, true);
    } catch (e) {}
    el._cardMobileGallery = null;
    el.dataset.cardMobileGalleryInitialized = 'false';
  }

  function initGallery(el) {
    if (!el || el.dataset.cardMobileGalleryInitialized === 'true') return;
    if (!mobileQuery || !mobileQuery.matches) return;
    if (el.querySelectorAll('.swiper-slide').length <= 1) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        initGallery(el);
      }, 50);
      return;
    }

    el._cardMobileGallery = new Swiper(el, {
      slidesPerView: 1,
      speed: 350,
      watchOverflow: true,
      nested: true,
      observer: true,
      observeParents: true,
    });
    el.dataset.cardMobileGalleryInitialized = 'true';

    requestAnimationFrame(function () {
      if (el._cardMobileGallery && typeof el._cardMobileGallery.update === 'function') {
        el._cardMobileGallery.update();
      }
    });
  }

  function sync(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-card-mobile-gallery]').forEach(function (el) {
      if (mobileQuery && mobileQuery.matches) {
        initGallery(el);
      } else {
        destroyGallery(el);
      }
    });
  }

  function onBreakpointChange() {
    sync(document);
  }

  function isInteractiveTarget(target) {
    return Boolean(
      target.closest(
        [
          'a',
          'button',
          'input',
          'select',
          'textarea',
          'label',
          'summary',
          'details',
          'product-form',
          'modal-opener',
          'quick-add-modal',
          'quick-add-bulk',
          'quantity-popover',
          '.custom-text-with-price',
          '.card-product-inline-form',
          '.card-product-bar-form',
          '.card-product-mobile-gallery',
        ].join(','),
      ),
    );
  }

  document.addEventListener('click', function (event) {
    if (!mobileQuery || !mobileQuery.matches) return;

    var wrapper = event.target.closest('.product-card-wrapper--mobile-gallery');
    if (!wrapper || isInteractiveTarget(event.target)) return;

    var link = wrapper.querySelector('.card__heading a[href]');
    if (!link || event.defaultPrevented) return;

    window.location.href = link.href;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync(document);
    });
  } else {
    sync(document);
  }

  if (mobileQuery) {
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onBreakpointChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onBreakpointChange);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    sync(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-card-mobile-gallery]').forEach(destroyGallery);
  });
})();
